import React from 'react';

class ReportJobDialogRow extends React.Component {
    render() {
        const {
            label,
            tooltip,
            value = '',
            children = null,
            classes = ''
        } = this.props;

        return (
            <div className={`dialog-row middle ${classes}`}>
                <div className="dialog-row-title">
                    {label}<br/>
                    <span>{tooltip}</span>
                </div>
                {children &&
                    <div className="dialog-row-value">{children}</div>
                }
                {!children &&
                    <div className="dialog-row-value">{value}</div>
                }
            </div>
        );
    }
}

export default ReportJobDialogRow;



// WEBPACK FOOTER //
// ./src/Fuse/components/ReportJobDialogRow.js